/**
 * 模板市场-Taber组件
 * @author VenDream, chenqunfeng
 * @since 18/06/05
 */
import Stat from '@fe/common/lib/stat';
// import { getUserGameAuth } from 'api/user';
import classnames from 'classnames';
import VARIABLES from 'constants/variable.json5';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
// import store from 'store';
import { getUrlPathname, sendStat } from 'utils/common';
import { isModuleHidden } from 'utils/hidden-modules';
import { getTabPath, ROUTER } from 'utils/store-tabs';
import { isInEditorIframe } from 'utils/env';
import './store-tabs.less';

const inEditorIframe = isInEditorIframe();

class StoreTabs extends Component {
  static propTypes = {
    user: PropTypes.object,
    tabs: PropTypes.array,
    activeIndex: PropTypes.number,
    setActiveTab: PropTypes.func,
    isJointLogin: PropTypes.bool,
    isShowOpenZone: PropTypes.bool,
    templateCategoryCustomsFlag: PropTypes.number,
    templateCategoryCustoms: PropTypes.string,
  };

  constructor() {
    super();
    // this.state = {
    //   // 用户是否有开通小游戏功能权限
    //   isUserGameAuth: false,
    // };
  }

  componentWillMount() {
    const pathname = getUrlPathname();
    // 模板市场被嵌套在编辑器中时 以翻页为默认tab
    const index = ROUTER[pathname] || (inEditorIframe ? 1 : 0);
    // const index = ROUTER[pathname] || 1;

    if (index !== undefined) {
      this.props.setActiveTab(index, `/${pathname}`);
    }
  }

  componentDidMount() {
    // history前进后退动作捕获
    window.addEventListener('popstate', e => {
      const value = e.target.location.pathname;
      const index = ROUTER[value] || 0;
      // 切换tab
      if (index !== undefined) {
        this.props.setActiveTab(index, `/${value}`);
      }
    });
    // this.fetchUserGameAuth();
  }

  /** 获取用户开通小游戏功能权限 */
  // fetchUserGameAuth = async () => {
  //   try {
  //     const { userInfo } = store.getState();
  //     const isUserGameAuth =
  //       userInfo && userInfo.userId && (await getUserGameAuth());
  //     this.setState({
  //       isUserGameAuth,
  //     });
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };

  // 渲染模板分类tab
  getStoreTabs() {
    const {
      tabs,
      activeIndex,
      isJointLogin,
      templateCategoryCustomsFlag,
      templateCategoryCustoms,
      isShowOpenZone,
    } = this.props;
    // const { isUserGameAuth } = this.state;
    const htmls = [];
    // 优化为只在编辑器中展示时才应用 templateCategoryCustoms 字段
    const filterTabs =
      inEditorIframe && isJointLogin && templateCategoryCustomsFlag === 1
        ? tabs.filter(v => templateCategoryCustoms.split(',').includes(v.name))
        : tabs;
    for (const tab of filterTabs) {
      const { index, name, text, hidden } = tab;
      const cls = classnames({
        tab: true,
        active: index === activeIndex,
        bounce: name === 'CHAJIAN' || name === 'POSTER',
        poster: name === 'POSTER',
        vip: name === VARIABLES.VIP && templateCategoryCustomsFlag,
      });

      // 不渲染搜索结果tab
      if (name === VARIABLES.SEARCH || hidden) {
        continue;
      }

      // 未登录用户和未开通用户小游戏tab隐藏--(去掉了用户开通小游戏权限校验接口，小游戏tab暂时隐藏)
      if (name === VARIABLES.RP_GAME) {
        continue;
      }

      // 正常的模板市场不显示 已开通的展示页模版 类型，只在被编辑器嵌套时显示
      if (!inEditorIframe && name === VARIABLES.OPENEDPAGE) {
        continue;
      }

      // 正常的模板市场不显示 已开通玩法模版 类型，只在被编辑器嵌套时显示
      if (!inEditorIframe && name === VARIABLES.OPENEDPLUGIN) {
        continue;
      }

      // 正常的模板市场不显示 平台专区 类型，只在用户联合登陆时显示
      if (!isShowOpenZone && name === VARIABLES.OPENZONE) {
        continue;
      }

      htmls.push(
        <li
          className={cls}
          key={index}
          data-name={name}
          onClick={this.selectTab.bind(this, index)}>
          <span className="tab-text">{text}</span>
        </li>
      );
    }

    return htmls;
  }

  selectTab = index => {
    window.location.href =
      getTabPath(index) + window.location.search.replace('false', true);
  };

  render() {
    // 是否隐藏 设计师招募
    const isBeADesignerHidden = isModuleHidden('be-a-designer');
    return (
      <div className="cmp store-tabs transitionable">
        <ul className="tabs-list">
          {this.getStoreTabs()}
          {!isBeADesignerHidden ? (
            <li
              className="designer-entry"
              onClick={() => {
                window.open(`${window.RPCONFIG.mainHost}/bedesigner.html`);
                sendStat(
                  'RP_STORE',
                  '模版市场',
                  '设计师招募按钮',
                  Stat.ACTION_CLICK,
                  {
                    id: 'web_mobanmarket_moban_shejishizhaomu_click',
                  }
                );
              }}>
              {'设计师招募 >'}
            </li>
          ) : null}
        </ul>
      </div>
    );
  }
}

export default StoreTabs;
